import { useContext, useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { ThemeContext } from "@/App";
import { CALENDLY_URL, buildCalendlyEmbedUrl } from "@/lib/calendly";

export default function BookingModal() {
  const [open, setOpen] = useState(false);
  const { theme } = useContext(ThemeContext);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("hlt:open-booking", handler);
    return () => window.removeEventListener("hlt:open-booking", handler);
  }, []);

  const dark = theme === "dark";
  const baseSrc = `${CALENDLY_URL}?embed_type=Inline&embed_domain=${window.location.hostname}&hide_gdpr_banner=1&background_color=${dark ? "0d2340" : "ffffff"}&text_color=${dark ? "e8edf5" : "1a1a1a"}&primary_color=c9a227`;
  const [src, setSrc] = useState(baseSrc);

  useEffect(() => {
    if (!open) return;
    let cancelled = false;
    buildCalendlyEmbedUrl(baseSrc).then((u) => {
      if (!cancelled) setSrc(u);
    });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, theme]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        data-testid="booking-modal"
        className="max-w-3xl overflow-hidden border-border bg-card p-0"
      >
        <DialogTitle className="sr-only">Book a free consultation</DialogTitle>
        {open && (
          <iframe
            title="Book a free consultation with Harrison Litigation Team"
            src={src}
            className="h-[72vh] w-full min-w-[320px] border-0"
          />
        )}
        <a
          data-testid="booking-fallback-link"
          href={CALENDLY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="block border-t border-border px-4 py-3 text-center font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground transition-colors duration-300 hover:text-gold"
        >
          Calendar not loading? Open the scheduler in a new tab
        </a>
      </DialogContent>
    </Dialog>
  );
}
